import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import * as _ from 'lodash';

import { Announcement } from '@src/redux/_reducers/appReducer';
import { RootState } from '@src/redux/_reducers/rootReducer';

export function useAnnouncement() {
  const announcements = useSelector(
    (state: RootState) => state.app.announcements
  );

  // Get the highest priority announcement
  const announcement = useMemo(() => {
    const announcementsList = Object.values(announcements);
    if (announcementsList.length === 0) return {} as Announcement;

    // Sort by priority (higher number = higher priority)
    const sortedAnnouncements = announcementsList.sort((a, b) => {
      const priorityA = a.priority || 0;
      const priorityB = b.priority || 0;
      return priorityB - priorityA;
    });

    return sortedAnnouncements[0];
  }, [announcements]);

  const isAnnouncementAvailable = !_.isEmpty(announcement);

  return {
    announcement,
    isAnnouncementAvailable
  };
}
